import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import {
  ticketDetailSearchSchema,
  withoutTicketDetailSearchDefaults,
  type TicketDetailSearch,
} from '@/components/Tickets/search'
import { TicketDetailPage } from '@/components/Tickets/TicketDetailPage'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/tickets/$ticketId/')({
  validateSearch: ticketDetailSearchSchema,
  component: TicketIdRoute,
})

function TicketIdRoute() {
  const { ticketId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  const onSearchChange = useCallback(
    (next: Partial<TicketDetailSearch>) =>
      void navigate({
        search: (current) => withoutTicketDetailSearchDefaults({ ...current, ...next }),
        replace: true,
      }),
    [navigate],
  )

  return <TicketDetailPage ticketId={ticketId} search={search} onSearchChange={onSearchChange} />
}
